var _defs, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyCircleLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130.79 131.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#13d15e;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 65.39,
    cy: 67.38,
    r: 54.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67,63c-9-2.35-12-4.78-12-8.57,0-4.34,4-7.36,10.75-7.36,7.09,0,9.72,3.38,10,8.36h8.8c-.28-6.85-4.46-13.14-12.78-15.17V31.53h-12v8.61c-7.73,1.67-13.94,6.69-13.94,14.37,0,9.2,7.61,13.78,18.72,16.45,10,2.39,12,5.89,12,9.6,0,2.75-2,7.13-10.76,7.13-8.2,0-11.43-3.67-11.86-8.37H45.12c.48,8.72,7,13.62,14.66,15.26v8.64h12V94.66c7.76-1.48,13.94-6,13.94-14.14C85.67,69.21,76,65.34,67,63Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyCircleLarge);
export default __webpack_public_path__ + "static/media/money_circle_large.6f5a4e80165038df57741d20c815efc0.svg";
export { ForwardRef as ReactComponent };